import { TextureData, TextureStatesData } from "../../types/types";
import { CardSuit } from "../card/Card";
import { LoaderFileKeys } from "../constant/AppConstants";


export enum TrumpIconType {
    RESULTS_SCREEN,
    SELECTED_TRUMP_VIEW,
    POPUP_CHOOSE_OR_TAKE_SUIT,
    PLAYER_SAY,
}

export function GetCardSuitIconTextureStatesData(
    cardSuit: CardSuit, 
    type: TrumpIconType
): TextureStatesData
{
    switch(cardSuit) {
        case CardSuit.CLUBS:
            switch(type) {
                // results screen:
                // white icons, only over state
                case TrumpIconType.RESULTS_SCREEN:
                return {
                    out: {texture: LoaderFileKeys.ui, frame: "icon-results-clubs-out.png"},
                };
                
                // choose/take suit popup and selected trump view ui share the same icons,
                // the latter scales it down
                case TrumpIconType.POPUP_CHOOSE_OR_TAKE_SUIT:
                case TrumpIconType.SELECTED_TRUMP_VIEW:
                case TrumpIconType.PLAYER_SAY:
                return {
                    out: {texture: LoaderFileKeys.ui, frame: "icon-choice-clubs-out.png"},
                    disabled: {texture: LoaderFileKeys.ui, frame: "icon-choice-clubs-disabled.png"},
                };
            }
            break;
        
        case CardSuit.DIAMONDS:
            switch (type) {
                case TrumpIconType.RESULTS_SCREEN:
                return {
                    out: {texture: LoaderFileKeys.ui, frame: "icon-results-diamonds-out.png"},
                };

                case TrumpIconType.POPUP_CHOOSE_OR_TAKE_SUIT:
                case TrumpIconType.SELECTED_TRUMP_VIEW:
                case TrumpIconType.PLAYER_SAY:
                return {
                    out: {texture: LoaderFileKeys.ui, frame: "icon-choice-diamonds-out.png"}, 
                    disabled: {texture: LoaderFileKeys.ui, frame: "icon-choice-diamonds-disabled.png"},
                };
            }
        
        case CardSuit.HEARTS:
            switch (type) {
                case TrumpIconType.RESULTS_SCREEN:
                return {
                    out: {texture: LoaderFileKeys.ui, frame: "icon-results-hearts-out.png"},
                };
                case TrumpIconType.POPUP_CHOOSE_OR_TAKE_SUIT:
                case TrumpIconType.SELECTED_TRUMP_VIEW:
                case TrumpIconType.PLAYER_SAY:
                return {
                    out: {texture: LoaderFileKeys.ui, frame: "icon-choice-hearts-out.png"},
                    disabled: {texture: LoaderFileKeys.ui, frame: "icon-choice-hearts-disabled.png"},
                };
            }
            break;
        
        case CardSuit.SPADES:
            switch (type) {
                case TrumpIconType.RESULTS_SCREEN:
                return {
                    out: {texture: LoaderFileKeys.ui, frame: "icon-results-spades-out.png"},
                };
                case TrumpIconType.POPUP_CHOOSE_OR_TAKE_SUIT:
                case TrumpIconType.SELECTED_TRUMP_VIEW:
                case TrumpIconType.PLAYER_SAY:
                return {
                    out: {texture: LoaderFileKeys.ui, frame: "icon-choice-spades-out.png"},
                    disabled: {texture: LoaderFileKeys.ui, frame: "icon-choice-spades-disabled.png"},
                };
            }
            break;

        default: 
            console.warn("GetIconTextureDataByCardSuit: unrecognized CardSuit:", cardSuit);
    }
    return null;
}